export const openIntercom = () => {
  if (typeof window.Intercom === 'function') {
    window.Intercom('show');

    return;
  }

  document.getElementById('intercomLauncher')?.click();
};
